import React from 'react';
import { Shirt } from 'lucide-react';
import { TSHIRT_SIZES } from './constants';

const StepAdditional = ({ formData, onChange }) => (
  <div className="form-step">
    <h3><Shirt size={20} /> Additional Information</h3>

    <div className="form-row">
      <div className="form-group">
        <label>T-Shirt Size *</label>
        <select name="tshirt_size" value={formData.tshirt_size} onChange={onChange}>
          <option value="">Select Size...</option>
          {TSHIRT_SIZES.map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>
    </div>

    <div className="form-group">
      <label>Previous Football/Cheer Experience</label>
      <textarea name="previous_experience" value={formData.previous_experience} onChange={onChange} placeholder="Describe any previous experience (teams, years played, positions, etc.)" rows={3} />
    </div>

    <div className="form-group">
      <label>Additional Discounts</label>
      <select name="discount_type" value={formData.discount_type} onChange={onChange}>
        <option value="">No additional discount</option>
        <option value="multi_child">Multi-Child Discount ($25 off - 2nd+ child)</option>
      </select>
    </div>
  </div>
);

export default StepAdditional;
